<div class="text-center" *ngIf="model.emailAddresses.value.length === 0">
    <span translate="CONFIRMATION_ADDITIONAL_EMAILS_NOT_AVAILABLE"></span>
</div>
<div [formGroup]="additionalEmailAddressesForm">
    <fieldset class="mb-3" *ngFor="let emailAddress of model.emailAddresses.value; index as mailIndex">
        <div class="row">
            <label class="col-2 col-form-label" translate="CONFIRMATION_ADDITIONAL_EMAILS_EMAIL_LABEL"></label>
            <div class="col-5">
                <pace-core-text-input
                    [(model)]="model.emailAddresses.value[mailIndex]"
                    [parentForm]="additionalEmailAddressesFormChildren"
                    [ariaLabel]="'CONFIRMATION_ADDITIONAL_EMAILS_EMAIL_LABEL' | translate"
                ></pace-core-text-input>
            </div>
            <div class="col-3">
                <button type="button" id="btnDelete" class="btn btn-warning" (click)="deleteEmailAddress(mailIndex)">
                    &times;
                </button>
            </div>
        </div>
    </fieldset>
</div>
<hr class="separator" />
<div class="row">
    <div class="col-2 offset-2">
        <button
            class="btn btn-primary ms-auto"
            (click)="addEmailAddress()"
            translate="CONFIRMATION_ADDITIONAL_EMAILS_ADD_EMAIL_LABEL"
        ></button>
    </div>
</div>
